/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class EtransportModifVehicleMetadataModel extends JSONable {
  licensePlate: string | null = null;
  firstTrailerLicensePlate: string | null = null;
  secondTrailerLicensePlate: string | null = null;
  shipmentDate: string | null = null;
  modificationDate: string | null = null;
}
